"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supplierAgreementsApiConfig = void 0;
const env_1 = require("../env/env");
const SUPPLIER_AGREEMENTS_CONTENT_URL = env_1.env.getString('SUPPLIER_AGREEMENTS_CONTENT_URL') || 'https://www.c2fo.dev/api/supplier-agreements';
exports.supplierAgreementsApiConfig = {
    SUPPLIER_AGREEMENTS_CONTENT_URL,
};
//# sourceMappingURL=supplierAgreementsApiConfig.js.map